

import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XHeader
},
data () {
return {
cur:1,
model:{Umobile:"",Ucontent:"",Uname:"",Umobile:"",Ucompany:""},
classifyList:[],
imgsList: [],
currentIndex: 0,   //默认显示图片
timer: null    
}
},
created(){
var cur=this.$route.query.cur
if(cur!=null && (cur==1||cur==4||cur==5)){
this.cur=cur
}
this.getHelpType();
this.runInv();
this.getBanners();
},
methods: {
goBack(){
this.$router.push({
path : '/developer/index',
query : {}
})
},
getPh(index){
this.classifyList[index].Switch = !this.classifyList[index].Switch
let tempArr = JSON.parse(JSON.stringify(this.classifyList))
this.classifyList = []
this.$nextTick(() => {
this.classifyList = tempArr
})
},
gotoPage(index) {
this.currentIndex = index;
},

runInv() {
this.timer = setInterval(() => {
this.gotoPage(this.nextIndex)
}, 3000)
},
getHelpType(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/mhelp/getList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.classifyList = res.body.rows;
console.log(res.body.rows);
var bin=this.classifyList.length;
for(var i=0;i<bin;i++){
this.classifyList[i].Switch=false;
this.classifyList[i].articleList=[];
this.classifyList[i].flag=false;
}
}
},function(res){
console.log(res.status);
});
},
getBanners(){
var sef=this
this.$http.post(this.global.httpUrl + '/rest/v1/m/mhelp/getBanners',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
sef.imgsList=res.body.imgs;

}
},function(res){
console.log(res.status);
});
},
getDetail(helpTypeId,helpTypeName,helpTypePName,id){

this.$router.push({
path : '/developer/detail',
query : {
helpTypeId: helpTypeId,
helpTypeName: helpTypeName,
helpTypePName: helpTypePName,
id: id
}
})
},
getArticleList(index,helpTypeId,e){

var obj=e.currentTarget;
var sef=this;
if(obj.classList.contains("open")){
obj.classList.remove("open")
sef.classifyList[index].flag=false;
return;
}else{
obj.classList.add("open")
}
this.$http.post(this.global.httpUrl + '/rest/v1/m/mhelp/getArticleList',{'helpTypeId':helpTypeId},{emulateJSON:true}).then(function(res){
if(res.body.success)
{
sef.classifyList[index].articleList = res.body.rows;
sef.classifyList[index].flag=true;
}
},function(res){
console.log(res.status);
});
},
goUrl(Url){
window.location.href = Url
},
open(url){
this.$router.push(url)
},
saveSuggest(){
var myreg = /^1[34578]\d{9}$/;
var Umobile =this.model.Umobile;
var Utitle = this.model.Utitle;
var Ucontent = this.model.Ucontent;
var Uname = this.model.Uname;
var Ucompany=this.model.Ucompany;
if(Umobile =null || Umobile=="" || Umobile==undefined){
alert("手机号码不能为空");
return;
}

if(Utitle =null || Utitle=="" || Utitle==undefined){
alert("主题不能为空")
return;
}
if(Ucontent =null || Ucontent=="" || Ucontent==undefined){
alert("反馈意见不能为空")
return;
}
if(Ucontent =null || Ucontent.length>500 || Ucontent==undefined){
alert("您输入的内容不能超过500字")
return;
}
console.log(Umobile);
if (!myreg.test(this.model.Umobile)) {
alert("手机号码有误")
return;
}
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/addSuggest',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
alert("提交成功");
window.location.reload();
}
},function(res){
console.log(res.status);
});
}
},
computed: {

prevIndex() {
if(this.currentIndex == 0) {
return this.imgsList.length - 1;
}else{
return this.currentIndex - 1;
}
},

nextIndex() {
if(this.currentIndex == this.imgsList.length - 1) {
return 0;
}else {
return this.currentIndex + 1;
}
}
}
}



// WEBPACK FOOTER //
// ./src/views/developer/developerIndex.vue